import { Component, OnInit } from '@angular/core';
import { CommonService } from '__services';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  src = 'https://logchain-live.s3.ap-southeast-1.amazonaws.com/privacy-policy/LogChain_Confidential_Privacy_Policy_Draft_V0.pdf';
  constructor(
    private common: CommonService
  ) { }

  ngOnInit(): void {
    // this.common.processDocumentFromUrl('privacy-policy/LogChain_Confidential_Privacy_Policy_Draft_V0.pdf').subscribe(
    //   url => this.src = url
    // )
  }
}
